
import Vue from "vue";
import { DataTableHeader } from "vuetify";
import {
  contactApi,
  ContactSearchRequest,
  ContactSearchResult,
  ContactSearchRow,
} from "@/api/contacts";

export default Vue.extend({
  name: "QuickContactSearch",
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    defaultReseller: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      givenName: "",
      surname: "",
      company: "",
      street: "",
      zipCode: "",
      city: "",
      country: "",
      emailAddress: "",
      phoneNumber: "",
      reseller: this.defaultReseller,
      placeOfExperience: false,
      customer: false,
      searchedContact: [] as ContactSearchRow[],
      searchingContact: false,
      searchContactTerm: "",
      headersSearchContactColumns: [
        {
          text: this.$t("Kunde"),
          sortable: false,
          width: "5%",
          value: "customer",
        },
        {
          text: this.$t("Anrede"),
          sortable: false,
          width: "5%",
        },
        {
          text: this.$t("Titel"),
          sortable: false,
          width: "5%",
        },
        {
          text: this.$t("Vorname"),
          sortable: false,
          width: "10%",
          value: "givenName",
        },
        {
          text: this.$t("Nachname"),
          sortable: false,
          width: "10%",
          value: "surname",
        },
        {
          text: this.$t("Firmenname"),
          sortable: false,
          width: "10%",
          value: "companyName",
        },
        {
          text: this.$t("Strasse"),
          sortable: false,
          width: "10%",
          value: "street",
        },
        {
          text: this.$t("PLZ"),
          sortable: false,
          width: "10%",
          value: "zipCode",
        },
        {
          text: this.$t("Ort"),
          sortable: false,
          width: "10%",
          value: "city",
        },
        {
          text: this.$t("Land"),
          sortable: false,
          width: "10%",
          value: "country",
        },
      ] as DataTableHeader[],
    };
  },
  watch: {
    showDialog: {
      handler: function () {
        this.show = this.showDialog;
      },
      immediate: true,
    },
  },
  methods: {
    closeSearchContactDialog() {
      this.searchedContact = [];
      this.searchContactTerm = "";
      this.$emit("closeDialog");
    },
    validateRequest(request: ContactSearchRequest) {
        let key: keyof ContactSearchRequest;
        const valuesValue: boolean[] = []
        for (key in request) {
            if ( typeof request[key] === "string"  ) {
                valuesValue.push(request[key] != null && (request[key]?.toString()?.length ?? 0) > 0);
            }
        }
        return valuesValue.some(value => value);
    },
    async fireSearchRequest() {
      this.searchedContact = [];
      this.searchingContact = true;
      const request =   {
            givenName: this.givenName,
            surname: this.surname,
            street: this.street,
            zipCode: this.zipCode,
            city: this.city,
            emailAddress: this.emailAddress,
            phoneNumber: this.phoneNumber,
            company: this.company,
            placeOfExperience: this.placeOfExperience,
            customer: this.customer,
            page: 1,
            pageSize: 1000,
        } as ContactSearchRequest

        if( this.validateRequest(request)) {
            contactApi
                .search(request)
                .then((res) => {
                    this.searchedContact = res.contacts;
                })
                .finally(() => (this.searchingContact = false))
                .catch((err) => {
                    console.log(err);
                });
        }
    },
    emitSelection(contactSearchResult: ContactSearchResult) {
      this.$emit("searchSelection", contactSearchResult);
    },
  },
});
